import axios, { InternalAxiosRequestConfig } from 'axios';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
let store: any;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const injectStore = (_store: any) => {
  store = _store;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
axios.interceptors.request.use((config: InternalAxiosRequestConfig<any>) => {
  const isApiUrl = config.url?.includes('/api/');
  if (isApiUrl) {
    const state = store.getState();
    // Cookie-auth mode (deployed, same-origin): send/receive the HttpOnly auth cookie. Only
    // when enabled — locally the FE is cross-origin and the BE returns `Access-Control-Allow-Origin: *`,
    // which the browser rejects for credentialed requests, so header mode must stay uncredentialed.
    if (state.configLoader?.appConfig?.cookieAuth === true) {
      config.withCredentials = true;
    }
    // Header is still used for the login call and for header-auth mode. After a reload in
    // cookie mode the in-memory token is gone, so we guard it and let the cookie carry auth.
    const { idToken } = state.auth;
    if (idToken) {
      config.headers.idToken = idToken;
    }
  }
  return config;
});
